import React, { Component } from "react";
import "./NodeManager.css";
import "./NetworkPage.css";
import "./Dashboard.css";
import NodeModal from "./NodeModal";
import DeleteModal from "./DeleteModal";
import ContactModal from "./ContactModal";
import DeleteExitModal from "./DeleteExitModal";
import ExitModal from "./ExitModal";
import ConfigModal from "./Configuration";
import UUIDModal from "./UUIDModal";
import axios from "axios";
import { Table } from "./Table";
import { withRouter } from "react-router";
import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";
import RemoveModal from "./RemoveModal";
import CSVModal from "./CSVModal";
import "animate.css";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: {
        eid: "",
        public_ip: "",
        port: "",
        owner: this.props.user,
        parent_node: "",
        inner_nodes: [],
      },
      configItem: {
        eid: "",
        private_ip: "",
        port: "",
        length: "",
      },
      leaveNetwork: {
        body: "",
        header: "",
        button: "",
      },
      baseNode: this.props.match.params.nodeId,
      validationErrors: [],
      network: {},
      nodeList: [],
      loadedNodeList: false,
      userInfo: {},
      baseNodeList: [],
      demoMode: this.getCookie("demoMode") ? this.getCookie("demoMode") === "true" : false,
      config: {
        config_file: "",
      },
      config_uuid: "",
      node_uuid: "",
      nodePagination: this.getCookie("nodepagination")
        ? parseInt(this.getCookie("nodepagination"))
        : 8,
    };
    this.newNode = React.createRef();
    this.newConfig = React.createRef();
    this.selectedRows = [];
  }

  getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  setNodePagination = (f, action) => {
    let newcount = Math.max(3, this.state.nodePagination - 1);
    if (action === "increase") {
      newcount = Math.min(20, this.state.nodePagination + 1);
    }
    document.cookie =
      "nodepagination = " + newcount + ";max-age=4320000;path=" + this.props.baseDir;
    f(newcount);
    this.setState({ nodePagination: newcount });
  };

  componentDidMount() {
    this.refreshList(null);
    this.getUserInfo();
  }

  getUserInfo = () => {
    axios
      .get(this.props.baseUrl + "/api/api/users/me/", {
        headers: this.getHeaders(),
      })
      .then((res) => {
        this.setState({ userInfo: res.data });
      })
      .catch((err) => {});
  };

  getHeaders = () => {
    return {
      Authorization: `Token ${this.props.token}`,
    };
  };

  downloadNetworkCSV = (network_uuid) => {
    axios
      .get(
        this.props.baseUrl +
          "/api/api/network/nodes_csv?uuid=" +
          network_uuid,
        {
          headers: this.getHeaders(),
        }
      )
      .then((res) => {
        const element = document.createElement("a");
        const file = new Blob([res.data], {
          type: "text/csv",
        });
        element.href = URL.createObjectURL(file);

        var d = new Date();
        element.download =
          "network_csv_utc_" +
          (parseInt(d.getUTCMonth()) + 1) +
          "-" +
          d.getUTCDate() +
          "-" +
          d.getUTCFullYear() +
          "_" +
          d.getUTCHours() +
          "h-" +
          d.getUTCMinutes() +
          "m.csv";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
      })
      .catch((err) => {});
  };

  downloadDynamicConfig = (url) => {
    axios
      .get(url, {})
      .then((res) => {
        const element = document.createElement("a");
        var file;
        if(res.headers["content-type"]==="application/json"){
          file = new Blob([JSON.stringify(res.data)], {
            type: "application/json",
          });
        }
        else{
          file = new Blob([res.data], {
            type: "text/plain",
          });
        }
        element.href = URL.createObjectURL(file);
        element.download = res.headers["content-disposition"].split('"')[1]
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
      })
      .catch((err) => {});
  };

  currentBaseNodes = () => {
    let nodeList = this.state.nodeList;
    var baseNodes = [];
    if (this.state.baseNode) {
      let baseNode = this.getBaseNode().eid.toString();
      for (let key in nodeList) {
        let node = nodeList[key];
        if (node["parent_node"] && node["parent_node"] === baseNode) {
          baseNodes.push(node);
        }
      }
    } else {
      for (let key in nodeList) {
        let node = nodeList[key];
        if (node["parent_node"] === null) {
          baseNodes.push(node);
        }
      }
    }
    return baseNodes;
  };

  getBaseNode = () => {
    let url_arguments = this.props.location.pathname.split("/");
    let last_node = url_arguments[url_arguments.length - 1];
    if (last_node === "") {
      last_node = url_arguments[url_arguments.length - 2];
    }
    let nodeList = [...this.state.nodeList];
    if (this.props.match.params.networkUUID) {
      for (let key in nodeList) {
        let node = nodeList[key];
        if (
          this.props.match.params.nodeId &&
          node["eid"].toString() === last_node
        ) {
          return node;
        }
      }
    }
    return null;
  };

  refreshList = () => {
    const networkUUID = this.props.match.params.networkUUID;
    axios
      .get(
        this.props.baseUrl +
          "/api/api/network/" +
          networkUUID +
          "/by_uuid",
        {
          headers: this.getHeaders(),
        }
      )
      .then((res) => {
        this.setState({ loadedNodeList: true });
        this.setState({ network: res.data });
        this.setState({ nodeList: this.state.network.nodes });
        this.setState({ baseNodeList: this.currentBaseNodes() });
      })
      .catch((err) => {});
  };

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;

    const error_tags = [
      "eid",
      "private_ip",
      "length",
      "public_ip",
      "port",
      "non_field_errors",
      "creation_error",
      "deletion_error",
    ];
    let errors = [];

    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      let error_msg = validationErrors[error_tags[i]];
      if (error_msg) {
        error_msg =
          error_msg.toString().charAt(0).toUpperCase() +
          error_msg.toString().slice(1);
        error_msg = error_msg.replace("eid", "EID");
        errors.push(<li key={error_tags[i]}>{error_msg}</li>);
      }
    }

    return errors;
  };

  toggle = () => {
    if (this.state.modal) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ modal: !this.state.modal });
  };

  toggleDemo = () => {
    if (this.state.demoMode) {
      document.cookie = "demoMode = false;max-age=4320000;path="+this.props.baseDir;
    } else {
      document.cookie = "demoMode = true;max-age=4320000;path="+this.props.baseDir;
    }
    window.location = this.props.baseDir + "/networks/" + this.state.network.uuid + "/";
  };

  exitToggle = () => {
    if (this.state.exitmodal) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ exitmodal: !this.state.exitmodal });
  };

  deleteExitToggle = () => {
    this.setState({ deleteExitModal: !this.state.deleteExitModal });
  };

  contactToggle = () => {
    this.setState({ customContact: !this.state.customContact });
  };

  configToggle = () => {
    if (this.state.configmodal) {
      this.setState({ validationErrors: [] });

      //Reset configuration tab
      const conf = { ...this.state.config, config_file: "" };
      this.setState({ config: conf });
      this.setState({ config_uuid: "" });
    }
    this.setState({ configmodal: !this.state.configmodal });
  };

  deleteToggle = () => {
    if (this.state.deletemodal) {
      this.setState({ validationErrors: [] });
    }
    let parent_node = this.getBaseNode();
    if (this.state.baseNodeList.length === 0 && this.state.baseNode) {
      window.location =
        this.state.baseDir+
        "/networks/" +
        this.state.network.uuid +
        "/" +
        (parent_node.parent_node ? parent_node["parent_node"] + "/" : "");
    }

    this.setState({ deletemodal: !this.state.deletemodal });
  };

  toggleCSV = () => {
    this.setState({ csvmodal: !this.state.csvmodal });
  };

  setRefreshTable = () => {
    this.setState({ refreshTable: !this.state.refreshTable });
  };

  getCLIredirect = async (node_uuid) => {
    let redirect_token = ''
    await axios
      .get(
        `${this.props.baseUrl}/api/api/nodes/${node_uuid}/cli_redirect_uuid/`,
        {
          headers: this.getHeaders(),
        }
      )
      .then((res) => {
        redirect_token = res.data
      })
      .catch((errors) => {
        //this.setState({ validationErrors: errors.response.data });
        redirect_token = 'Failed'
      });
    return redirect_token;
  };

  deleteExitSubmit = (item) => {
    axios
      .post(
        `${this.props.baseUrl}/api/api/nodes/${item.uuid}/unassign_gateway/`,
        {},
        {
          headers: this.getHeaders(),
        }
      )
      .then(async (res) => {
        this.notify_delete_exit();
        this.setState({ validationErrors: [] });
        this.deleteExitToggle();
        this.refreshList(null);
        if (this.state.baseNodeList.length === 1) {
          let parent_node = this.getBaseNode();
          window.location =
            "/networks/" +
            this.state.network.uuid +
            "/" +
            (parent_node.parent_node ? parent_node["parent_node"] + "/" : "");
        }
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  exitSubmit = (item) => {
    axios
      .post(
        `${this.props.baseUrl}/api/api/nodes/${item.uuid}/assign_gateway/`,
        { new_parent: item.parent_node },
        {
          headers: this.getHeaders(),
        }
      )
      .then((res) => {
        this.notify_exit();
        this.setState({ validationErrors: [] });
        this.exitToggle();
        this.refreshList(null);
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  handleSubmit = async (item, AMICheck) => {
    let valid = true;
    item["ami_enabled"] = AMICheck;
    item["network"] = this.state.network.uuid;
    delete item["parent_node"];

    // If node already exists (this is a node edit)
    if (!this.state.adding) {
      await axios
        .put(
          `${this.props.baseUrl}/api/api/nodes/${item.uuid}/put_uuid/`,
          item,
          {
            headers: this.getHeaders(),
          }
        )
        .then((res) => {
          this.notify_edit();
          this.setState({ validationErrors: [] });
          this.setState({ modal: false });
          this.refreshList(null);
        })
        .catch((errors) => {
          this.setState({ validationErrors: errors.response.data });
          valid = false;
        });
      return valid;
    }
    if (this.getBaseNode()) {
      item["parent_node"] = this.getBaseNode().uuid;
    }
    item["network"] = this.state.network.uuid;

    await axios
      .post(this.props.baseUrl + "/api/api/nodes/", item, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        if (item["parent_node"] !== "") {
          this.refreshList(item.eid);
        } else {
          this.refreshList(null);
        }

        this.notify_add();
        this.setState({ validationErrors: [] });
        this.setState({ modal: false });
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
        valid = false;
      });
    return valid;
  };

  handleSubmit_quiet = (item) => {
    axios
      .put(
        `${this.props.baseUrl}/api/api/nodes/${item.uuid}/put_uuid/`,
        item,
        {
          headers: this.getHeaders(),
        }
      )
      .then((res) => {
        this.setState({ validationErrors: [] });
        this.refreshList(null);
      })
      .catch((errors) => {});
    return;
  };

  config_uuid = () => {
    return this.state.config_uuid;
  };

  postConfig = () => {
    let service = axios.create({
      baseURL: this.props.baseUrl + "/api",
      responseType: "text",
    });

    service
      .post("/api/config/", this.state.config, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        this.setState({ config_uuid: response.data.uuid });
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  handleContact = (contactPlan) => {
    var contact_plan = { contact_plan: contactPlan };

    axios
      .post(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/post_contact/",
        contact_plan,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.refreshList(null);
        this.setState({ customContact: false });
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response });
      });
    return;
  };

  handleDelete = async (item) => {
    let valid = true;
    await axios
      .delete(
        `${this.props.baseUrl}/api/api/nodes/${item.uuid}/delete_uuid/`,
        {
          headers: this.getHeaders(),
        }
      )
      .then(async (res) => {})
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
        valid = false;
      });
    return valid;
  };

  deleteItem = (item) => {
    this.setState({ activeItem: item, deletemodal: !this.state.deletemodal });
  };

  createItem = () => {
    const item = {
      eid: "",
      public_ip: "",
      port: "",
      owner: this.props.user,
      inner_nodes: "",
    };
    this.setState({ activeItem: item, adding: true, modal: !this.state.modal });
  };

  createConfig = async (node) => {
    await this.setState({ configItem: node });
    this.setState({ configmodal: !this.state.configmodal });
  };

  configurationGen = () => {
    this.setState({ conf: !this.state.conf });
  };

  editItem = (item) => {
    const selectedItem = item.map((row) => row.original)[0];
    this.setState({
      activeItem: selectedItem,
      adding: false,
      modal: !this.state.modal,
    });
  };

  viewUUID = (item) => {
    const selectedItem = item.map((row) => row.original)[0];
    this.setState({ node_uuid: selectedItem.uuid });
    this.setState({ UUIDmodal: true });
    return;
  };

  assignExit = (item) => {
    const selectedItem = item.map((row) => row.original)[0];
    this.setState({
      activeItem: selectedItem,
      exitmodal: !this.state.exitmodal,
    });
  };

  customContact = () => {
    this.setState({
      customContact: !this.state.customContact,
    });
  };

  deleteExit = (item) => {
    this.setState({
      activeItem: item,
      deleteExitModal: !this.state.deleteExitModal,
    });
  };

  toggleModal = (toggle) => {
    if (this.state[toggle]) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ [toggle]: !this.state[toggle] });
  };

  toggleLeaveNetwork = () => {
    var leaveNetwork = { ...this.state.leaveNetwork };

    let admins = this.state.network.admins;
    let users = this.state.network.users;
    let user = this.props.user;

    // User is last admin
    if (admins.includes(user) && admins.length === 1) {
      // Last user of network, warn that this will delete the network completely
      if (users.length === 1) {
        leaveNetwork.header = "Leave network";
        leaveNetwork.body = (
          <>
            You are the last user of the network.
            <br />{" "}
            <b>
              Leaving will delete any remaining nodes and remove the network
              permanently.
            </b>
          </>
        );
        leaveNetwork.button = "Leave and delete network";
      }

      // Last user of network, cannot leave until another user is made admin
      else {
        leaveNetwork.header = "Cannot leave network";
        leaveNetwork.body = (
          <>
            You are the last admin in the network.
            <br />{" "}
            <b>
              Please grant admin rights to at least one other user to be able to
              leave the network.
            </b>
          </>
        );
        leaveNetwork.button = "";
      }
    }

    // User is not last admin, leave warning that user nodes will be removed
    else {
      leaveNetwork.header = "Leave network";
      leaveNetwork.body = (
        <>
          Are you sure you want to leave the network?
          <br />
          <b>
            Leaving will permanently delete any remaining nodes that you own.
          </b>
        </>
      );
      leaveNetwork.button = "Leave network";
    }

    this.setState({ leaveNetwork });
    this.setState({ leaveNetworkModal: true });
  };

  leaveNetwork = () => {
    const formData = new FormData();
    this.state.network.users.forEach((user) => {
      if (user.username === this.props.user) {
        formData.append("remove-users", user.email);
      }
    });
    formData.append("_method", "PATCH");

    this.setState({ leaveNetworkModal: false });

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/users/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        window.location = "/networks/";
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  render() {
    return (
      <div className="dashboard">
        <div className="node_table">
          {this.state.nodeList ? (
            <Table
              baseDir={this.props.baseDir}
              baseUrl={this.props.baseUrl}
              token={this.props.token}
              network={this.state.network}
              baseNode={this.getBaseNode()}
              nodeItems={this.state.baseNodeList}
              loadedNodeList={this.state.loadedNodeList}
              editItem={this.editItem}
              viewUUID={this.viewUUID}
              assignExit={this.assignExit}
              customContact={this.customContact}
              deleteExit={this.deleteExit}
              handleDelete={this.deleteItem}
              handleSubmit={this.handleSubmit_quiet}
              getCLIredirect={this.getCLIredirect}
              createItem={this.createItem}
              createConfig={this.createConfig}
              leaveNetwork={this.toggleLeaveNetwork}
              user={this.props.user}
              toggleCSV={this.toggleCSV}
              nodePagination={this.state.nodePagination}
              setNodePagination={this.setNodePagination}
              demoMode={this.state.demoMode}
              toggleDemo={this.toggleDemo}
              isStaff={this.state.userInfo.is_staff}
            />
          ) : null}
        </div>

        {this.state.modal ? (
          <NodeModal
            baseUrl={this.props.baseUrl}
            token={this.props.token}
            ref={this.newNode}
            activeItem={this.state.activeItem}
            toggle={this.toggle}
            getErrors={this.renderErrors}
            onSave={this.handleSubmit}
            isStaff={this.state.userInfo.is_staff}
            adding={this.state.adding}
            demoMode={this.state.demoMode}
          />
        ) : null}

        {this.state.leaveNetworkModal ? (
          <RemoveModal
            toggle={this.toggleModal}
            toggleName="leaveNetworkModal"
            onSave={this.leaveNetwork}
            message_body={this.state.leaveNetwork.body}
            message_header={this.state.leaveNetwork.header}
            saveButton={this.state.leaveNetwork.button}
          />
        ) : null}

        {this.state.deletemodal ? (
          <DeleteModal
            ref={this.newNode}
            item={this.state.activeItem}
            toggle={this.deleteToggle}
            onSave={this.handleDelete}
            refreshList={this.refreshList}
          />
        ) : null}

        {this.state.customContact ? (
          <ContactModal
            baseUrl={this.props.baseUrl}
            token={this.props.token}
            network={this.state.network}
            toggle={this.contactToggle}
            getErrors={this.renderErrors}
            onSave={this.handleContact}
          />
        ) : null}

        {this.state.configmodal ? (
          <ConfigModal
            baseUrl={this.props.baseUrl}
            base={this.props.base}
            ref={this.newConfig}
            nodeList={this.state.nodeList}
            user={this.props.user}
            configItem={this.state.configItem}
            configToggle={this.configToggle}
            getHeaders={this.getHeaders}
            getErrors={this.renderErrors}
            config={this.state.config.config_file}
            download={this.downloadDynamicConfig}
            token={this.props.token}
          />
        ) : null}

        {this.state.csvmodal ? (
          <CSVModal
            baseUrl={this.props.baseUrl}
            token={this.props.token}
            toggle={this.toggleModal}
            toggleName="csvmodal"
            network_uuid={this.state.network.uuid}
            downloadCSV={this.downloadNetworkCSV}
          />
        ) : null}

        {this.state.exitmodal ? (
          <ExitModal
            ref={this.newConfig}
            nodeList={this.currentBaseNodes()}
            user={this.props.user}
            activeItem={this.state.activeItem}
            exitToggle={this.exitToggle}
            getErrors={this.renderErrors}
            onSave={this.exitSubmit}
          />
        ) : null}

        {this.state.deleteExitModal ? (
          <DeleteExitModal
            ref={this.newNode}
            item={this.state.activeItem}
            toggle={this.deleteExitToggle}
            onSave={this.deleteExitSubmit}
          />
        ) : null}

        {this.state.UUIDmodal ? (
          <UUIDModal
            title="Node UUID"
            info="Unique identifier for a node. Use this token to facilitate remote node set up."
            uuid={this.state.node_uuid}
            toggle={this.toggleModal}
            toggleName="UUIDmodal"
          />
        ) : null}
      </div>
    );
  }

  notify_add = () => {
    store.addNotification({
      title: "Success!",
      type: "success",
      message: "Node Added",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_edit = () => {
    store.addNotification({
      type: "info",
      message: "Node Successfully Edited",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_exit = () => {
    store.addNotification({
      type: "info",
      message: "Gateway successfully set",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_delete_exit = () => {
    store.addNotification({
      type: "info",
      message: "Gateway successfully unassigned",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_delete = () => {
    store.addNotification({
      type: "danger",
      message: "Node was deleted from database",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };
}

export default withRouter(Dashboard);
